import React from 'react';
import FeatureCards from "../../components/FeatureCards/FeatureCards";
import CTA from "../../components/Constant/cta/CTA";
import TimelineSection from "../../components/TimelineSection/TimelineSection";
import WhySection from "../../components/WhySection/WhySection";
import LocationTimeline from "../../components/LocationTimeline/LocationTimeline";
import IntroSection from "../../components/IntroSection/IntroSection";
import FAQList from "../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../components/InfoBlocks/InfoBlocks";
import ServiceCards from "../../components/ServiceCards/ServiceCards ";
import ComparisonTable from "../../components/ComparisonTable/ComparisonTable";

export default function MaltaJurisdiction() {

    return (
        <main className='main'>

            <IntroSection
                title="Malta Jurisdiction"
                subtitle="The EU’s Leading Hub for Gaming, Finance & Blockchain Licensing"
                description="Malta has established itself as one of the world’s most trusted and recognized jurisdictions for iGaming, financial services, payments, asset management, insurance, and blockchain licensing. With a robust legal framework, EU membership, and strong regulatory authorities like the Malta Gaming Authority (MGA) and the Malta Financial Services Authority (MFSA), Malta is the gold standard for businesses seeking credibility, recognition, and EU market access."
                badges={[
                    "EU Member State",
                    "Global Recognition",
                    "Passporting Rights",
                    "Credible Regulators"
                ]}
                buttonText="Request a Malta Licensing Proposal →"
                buttonLink="/quote"
                imageSrc={require('../../assets/images/jurisdictions/malta-jurisdiction.png')}
                imageAlt="Malta Jurisdiction Licensing"
            />


            <section className='section'>
                <div className="container">
                    <WhySection
                        title="Why Choose Malta?"
                        blocks={[
                            {
                                items: [
                                    { text: "EU & Global Recognition — trusted by investors, PSPs, and regulators worldwide." },
                                    { text: "iGaming Hub — the first EU country to regulate online gaming (2004)." },
                                    { text: "Blockchain Island — one of the first to introduce comprehensive VFA crypto regulations." },
                                    { text: "Financial Services Excellence — investment firms, banks, and EMIs licensed under EU rules." },
                                    { text: "Regulated & Compliant — strong AML/KYC frameworks aligned with FATF & EU directives." },
                                    { text: "Passporting Rights — once licensed in Malta, businesses can operate across the European Economic Area (EEA)." }
                                ]
                            }
                        ]}
                    />

                    <InfoBlocks
                        title="Key Licensing Sectors in Malta"
                        blocks={[
                            {
                                title: "Gaming & iGaming (MGA)",
                                items: [
                                    { text: "B2C Gaming License — operate online casinos, sportsbooks, poker, lotteries." },
                                    { text: "B2B Gaming License — provide gaming platforms/software." },
                                    { text: "Recognized as one of the most prestigious gaming licenses globally." }
                                ]
                            },
                            {
                                title: "Financial & Brokerage (MFSA)",
                                items: [
                                    { text: "Investment Firms — forex, CFDs, portfolio management." },
                                    { text: "Clearing & Custody Firms — regulated under MiFID II." },
                                    { text: "High credibility but high capital requirements." }
                                ]
                            },
                            {
                                title: "Virtual Financial Assets (Crypto)",
                                items: [
                                    { text: "VFA Class 1–4 Licenses — advisory, brokerage, custody, and crypto exchange operations." },
                                    { text: "Malta is known as the “Blockchain Island.”" }
                                ]
                            },
                            {
                                title: "Banking & Payments",
                                items: [
                                    { text: "Credit Institution License — full EU banking license." },
                                    { text: "PSP & EMI Licenses — payment processing, wallets, IBAN, card issuing." },
                                    { text: "EU-wide payment passporting rights." }
                                ]
                            },
                            {
                                title: "Insurance & Reinsurance",
                                items: [
                                    { text: "Insurance Companies — life, non-life, captives." },
                                    { text: "Reinsurance Companies — international reinsurance." },
                                    { text: "One of the EU’s leading hubs for captive insurance." }
                                ]
                            },
                            {
                                title: "Funds & Asset Management",
                                items: [
                                    { text: "UCITS & AIFM Licenses — for retail and alternative investment funds." },
                                    { text: "Professional Investor Funds (PIFs) — for HNWIs & institutional investors." },
                                    { text: "Recognized across the EU and beyond." }
                                ]
                            }
                        ]}
                    />


                    <WhySection
                        title="Benefits of Malta Jurisdiction"
                        blocks={[
                            {
                                items: [
                                    { text: "Prestige & Trust — Tier-1 EU regulator." },
                                    { text: "Strong Legal Framework — based on EU directives & international standards." },
                                    { text: "Investor Confidence — attracts institutional investors and banking partners." },
                                    { text: "Banking & PSP Friendly — easier integration with major EU financial networks." },
                                    { text: "Multi-Sector Hub — gaming, crypto, finance, and insurance all under one jurisdiction." }
                                ]
                            }
                        ]}
                    />

                    <WhySection
                        title="Challenges to Consider"
                        blocks={[
                            {
                                items: [
                                    { text: "Higher Costs — setup and annual renewals are significantly more expensive than offshore centers." },
                                    { text: "Capital Requirements — minimum capital from €50k up to €5M depending on license type." },
                                    { text: "Longer Timelines — approvals can take 6–18 months." },
                                    { text: "Strict Compliance — ongoing audits, local presence, and reporting obligations." }
                                ]
                            }
                        ]}
                    />

                    <ComparisonTable
                        title="Malta vs Offshore Jurisdictions"
                        columns={columns}
                        data={data}
                    />

                    <DetailsSection
                        title='Why Offshore Advisory?'
                        items={
                            [
                                { text: "Experts in both EU and offshore licensing" },
                                { text: "Step-by-step guidance through MGA, MFSA, and VFA licensing" },
                                { text: "End-to-end service: incorporation, compliance, licensing, banking" },
                                { text: "Comparison support — Malta vs offshore hubs — to match your budget and goals" }
                            ]
                        }
                    />

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <Testimonials
                        title="Client Testimonials"
                        testimonials={testimonialsData}
                    />

                    <CTA
                        title="Looking for the highest credibility for your business?"
                        description="Malta offers EU-tier licenses in gaming, finance, payments, and blockchain. While more costly than offshore jurisdictions, Malta is the gold standard for global recognition."
                        buttonText="Book a Malta Consultation →"
                        buttonLink="/quote"
                    />

                </div>
            </section>
        </main>
    );
};

const faqData = [
    {
        question: "Is Malta the best jurisdiction for gaming?",
        answer: "Yes — Malta Gaming Authority (MGA) licenses are among the most prestigious and recognized globally.",
    },
    {
        question: "How long does it take to get licensed?",
        answer: "Gaming: 6–12 months | Financial/EMI: 6–9 months | Banking: 12–18 months.",
    },
    {
        question: "What are the main drawbacks?",
        answer: "High cost, high capital, and strict compliance compared to offshore centers.",
    },
    {
        question: "Do Malta licenses allow EU passporting?",
        answer: "Yes — once licensed, you can operate across the entire EEA market.",
    },
    {
        question: "Is Malta good for crypto?",
        answer: "Yes — Malta’s VFA Act is one of the first EU frameworks for crypto regulation.",
    },
];

const testimonialsData = [
    {
        quote: "We obtained an MGA license with Offshore Advisory. The process was strict but worth it — now our casino has EU-wide recognition.",
        author: "James R.",
        role: "Gaming Operator"
    },
    {
        quote: "Offshore Advisory guided us through a Malta EMI license. Complex but highly credible in the EU market.",
        author: "Sofia K.",
        role: "FinTech Founder"
    }
];

const columns = [
    "feature",
    "Malta (EU)",
    "Mwali (Comoros)",
    "Anjouan (Comoros)",
    "Western Sahara (CRA)"
];

const data = [
    {
        feature: "Recognition",
        "Malta (EU)": "Tier-1 EU",
        "Mwali (Comoros)": "Offshore",
        "Anjouan (Comoros)": "Emerging Offshore",
        "Western Sahara (CRA)": "New Offshore",
    },
    {
        feature: "Setup Time",
        "Malta (EU)": "6–18 months",
        "Mwali (Comoros)": "8–12 weeks",
        "Anjouan (Comoros)": "4–8 weeks",
        "Western Sahara (CRA)": "4–8 weeks",
    },
    {
        feature: "Capital Requirement",
        "Malta (EU)": "€50k–€5M",
        "Mwali (Comoros)": "$50k–250k+",
        "Anjouan (Comoros)": "None",
        "Western Sahara (CRA)": "None",
    },
    {
        feature: "Costs",
        "Malta (EU)": "High",
        "Mwali (Comoros)": "Moderate",
        "Anjouan (Comoros)": "Low",
        "Western Sahara (CRA)": "Low",
    },
    {
        feature: "Best For",
        "Malta (EU)": "Institutional, EU market access",
        "Mwali (Comoros)": "Brokers, banks, gaming",
        "Anjouan (Comoros)": "Startups, crypto, gaming",
        "Western Sahara (CRA)": "Multi-sector startups",
    },
];